export default __webpack_public_path__ + "static/media/marginrate_2025_nalsoft.53fb912f.pdf";